import React, { Fragment, useState, useEffect } from 'react';
import LaunchIcon from '@material-ui/icons/Launch';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import { Col, Container, Row, Button } from 'reactstrap'
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashAlt, faCheck } from "@fortawesome/free-solid-svg-icons";
import AlertModal from '../../../../shared/components/Modal';
import UpdateModalRequirementsStudio from "./UpdateModalRequirementsStudio";
import ApiClinicalStudio from '../../api/clinical_studio_api';

const ListRequirementsActions = ({ data, state }) => {
    const history = useHistory();
    const feasibility = data.original.feasibility;
    const [openModal, setOpenModal] = React.useState(false);

    const [showDeleteModal, setDeleteModal] = React.useState(false);
    const [successModal, setSuccessModal] = React.useState(false);
    const [errorModal, setErrorModal] = React.useState(false);

    useEffect(() => {

    }, []);

    const updateStateRequirement = (value) => {
        let dataReq = new FormData();
        dataReq.append("id_requerimiento", data.original.id_requerimiento);
        dataReq.append("estado", value);
        fetch(`${process.env.REACT_APP_PUBLIC_URL}requerimientos/actualizar-estado`, {
            method: 'PUT',
            headers: {
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: dataReq
        }).then(response => response.json()).then(data => {
            refreshRequirements();
        }).catch(error => console.log(error));
    }

    const refreshRequirements = async () => {
        try
        {
            await ApiClinicalStudio.checkStatusClinicalStudio(data.original.feasibility.id_estudio);
        }
        catch (e)
        {
            console.log("Error actualizando el estado del estudio")
        }
        let _url = "/clinical-studio/requirements";
        if (window.location.pathname === process.env.PUBLIC_URL + _url) {
            history.replace(process.env.PUBLIC_URL+"/");
            setTimeout(() => {
                history.push({
                    pathname: process.env.PUBLIC_URL + _url,
                    state: data.original.feasibility
                });
            }, 0);
        }
    }

    const updatingRequirement = () => {
        setOpenModal(true);
    }

    const deleteRequirement = () => 
    {
        let dataReq = new FormData();
        dataReq.append("id_requerimiento", data.original.id_requerimiento);
        fetch(`${process.env.REACT_APP_PUBLIC_URL}requerimientos/delete`, {
            method: 'DELETE',
            headers: {
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: dataReq
        }).then(response => response.json()).then(data => {
            setSuccessModal(true);
        }).catch(error => setErrorModal(false));
    }

    const finishDeleteModal = () => 
    {
        refreshRequirements();
    }

    return (<Fragment>
        <td role="cell">
            {
                data.original.estado == true ?
                    <IconButton className="text-success" style={{ fontSize: '15px' }} onClick={() => updateStateRequirement(false)}>
                        <FontAwesomeIcon icon={faCheck} />
                    </IconButton>
                    :
                    <IconButton className="text-danger" style={{ fontSize: '15px' }} onClick={() => updateStateRequirement(true)}>
                        <FontAwesomeIcon icon={faCheck} />
                    </IconButton>
            }
            <IconButton style={{ fontSize: '15px' }} onClick={() => updatingRequirement()}>
                <FontAwesomeIcon icon={faEdit} />
            </IconButton>
            <IconButton style={{ fontSize: '15px' }} onClick={() => setDeleteModal(true)}>
                <FontAwesomeIcon icon={faTrashAlt} />
            </IconButton>

            <UpdateModalRequirementsStudio
                opened={openModal}
                requirement={data.original}
                closeModal={() => setOpenModal(false)}
                id_estudio={feasibility.id_estudio}
                id_tercero={feasibility.id_tercero}
            />

            <AlertModal
                color="warning"
                title="Esta seguro de eliminar este requerimiento?"
                modal={showDeleteModal}
                onOk={() => deleteRequirement()}
                toggle={() => setDeleteModal(false)}
            />

            <AlertModal
                color="success"
                title="Requerimiento eliminado correctamente"
                modal={successModal}
                onOk={() => finishDeleteModal(false)}
                toggle={() => setSuccessModal(false)}
            />

            <AlertModal
                color="danger"
                title="Ha ocurrido un error al eliminar el Requerimiento"
                modal={errorModal}
                onOk={() => setErrorModal(false)}
                toggle={() => setErrorModal(false)}
            />
        </td>
    </Fragment>)
}

export default reduxForm({
    form: `modal-form`, // a unique identifier for this form
})(withTranslation('common')(ListRequirementsActions));